import React, {useEffect, useState} from "react";
import {getDocumentList} from "../api/admin/documentReq";
import useAuth from "../hooks/useAuth";
import FormButtons from "./common/FormButtons";

export default function DocumentListModal({ setShowDocModal }) {
    const { auth } = useAuth();
    const token = auth?.token;
    const [documentList, setDocumentList] = useState();
    const ROOT_FOLDER = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL

    const apiDocumentList = async () => {
        if (!documentList) {
            const response = await getDocumentList(token)
            setDocumentList(response)
        }
    };

    useEffect(() => {
        apiDocumentList()
    }, []);

    return (
        <fieldset className="flex">
            <legend>Liste des documents</legend>
            <div className="doc-modal-list">
                {documentList?.filter(document => (document?.enabled === true && document?.type !== 1 && (document?.url || document?.fileName)))
                    .map((document, index) => {
                        return (
                            <a target="_blank" key={index} href={(document?.fileName != null) ? `${ROOT_FOLDER}/documents/${document?.fileName}` : `${document?.url}`}>
                                <li key={document?.id}>{document?.name.toLocaleLowerCase()}</li>
                            </a>
                        )
                    })
                }
            </div>
            <div className="buttons-container back">
                <button onClick={() => setShowDocModal(false)} type="button" className="blue-button"><i className="fa fa-arrow-left"/><span>Retour</span></button>
            </div>
        </fieldset>
    )
}